import React, { createContext, useContext, ReactNode } from "react";
import { usePendingInvitations } from "../hooks/usePendingInvitations";
import type { PendingInvitation } from "../types/invite";

interface PendingInvitationsContextValue {
  invitations: PendingInvitation[];
  count: number;
  loading: boolean;
  accept: (_id: number) => Promise<number>;
  reject: (_id: number) => Promise<void>;
  refresh: () => Promise<void>;
}

const inertDefault: PendingInvitationsContextValue = {
  invitations: [],
  count: 0,
  loading: false,
  accept: async () => 0,
  reject: async () => {},
  refresh: async () => {},
};

const PendingInvitationsContext = createContext<PendingInvitationsContextValue>(inertDefault);

interface PendingInvitationsProviderProps {
  children: ReactNode;
}

export const PendingInvitationsProvider: React.FC<PendingInvitationsProviderProps> = ({
  children,
}) => {
  const value = usePendingInvitations();
  return (
    <PendingInvitationsContext.Provider value={value}>
      {children}
    </PendingInvitationsContext.Provider>
  );
};

export const usePendingInvitationsContext = (): PendingInvitationsContextValue => {
  return useContext(PendingInvitationsContext);
};
